module.exports = __webpack_public_path__ + "img/404.db52511c.png";